<template>
  <div class="c-my-music-expand-download">
    <ul class="cover-name-list">
      <li class="cover-name-list__item" v-for="d of downloadHistoryList" :key="d.accountDownloadHistoryUid">
        <img class="cover-name-list__item__cover" :src="imageSource(d.cover)" />
        <p class="cover-name-list__item__name">{{ d.trackTitle }}{{ getSubInfo(d.editType, d.versionType) }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import { defineComponent, computed, watch } from 'vue';
// import { useMessage } from 'naive-ui';
import useRequest from '@/hooks/useRequest';
import { getAccountDownloadHistoryListAPI } from '@/api/myMusicDownloadHistory';
import imageSource from '@/utils/imageSource';
import { useCacheStore } from '@/store/cache';
import getSubInfo from '@/utils/getSubInfo';

export default defineComponent({
  name: 'MyMusicExpandDownload',
  setup() {
    // const message = useMessage();
    const { request, response, isLoading } = useRequest(getAccountDownloadHistoryListAPI);

    const cacheStore = useCacheStore();
    const downloadHistoryList = computed(() => cacheStore.myMusicExpandDownloadHistory);

    const getAccountDownloadHistoryList = () => {
      // 沒快取新列表了 #POINTMUSIC-1131
      // if (downloadHistoryList.value.length) return;

      request({
        in: {
          // keyword: '',
          paginationInfo: {
            currentPage: 1,
            pageSize: 50,
          },
        },
      });
    };
    getAccountDownloadHistoryList();

    watch(response, () => {
      const [err, res] = response.value;

      if (err) {
        // message.error(err.message);
        return;
      }

      if (res) {
        const { data } = res.getAccountDownloadHistoryList;
        cacheStore.saveMyMusicExpandDownloadHistory(data);
      }
    });

    return {
      isLoading,
      imageSource,
      downloadHistoryList,
      getSubInfo,
    };
  },
});
</script>

<style lang="scss" scoped>
.cover-name-list {

  &__item {
    @include flex();
    @include padding(5px);
    background-color: $c-white;
    height: 40px;
    border-radius: 3px;

    &+& {
      margin-top: 12px;
    }

    &__cover {
      width: 30px;
      height: 30px;
    }

    &__name {
      margin-left: 16px;
      @include font-style($c-black, 14, 600, 0.7px, 26px);
      @include word-ellipsis;

    }
  }
}
</style>
